import { observable, runInAction } from 'mobx';
import {
  IWasteHandoverPlanServices,
  WasteHandoverPlanCreateRequest,
  WasteHandoverPlanExportPayload,
  WasteHandoverPlanModel,
  WasteHandoverPlanSearchPayload,
  WasteHandoverPlanSendEmailPayload,
  WasteHandoverPlanUpdateRequest,
  WasteHandoverRegistrationCreateRequest,
  WasteHandoverRegistrationSearchPayload,
  WasteHandoverRegistrationUpdateRequest,
} from 'services/Main/wasteHandoverPlan_services';
import { DataResponse } from 'services/response';
import { PurchaseOrderStore } from './purchaseOrder_store';
import { SearchHistory } from 'services/Main/purchaseOrder_services';
import { HistoryEditModel } from 'models/DeliveryRegistration';

export type WasteHandoverPlanStore = {
  searchWasteHandoverPlanResponse: DataResponse<WasteHandoverPlanModel[]>;
  createWasteHandoverPlanResponse: DataResponse<any>;
  updateWasteHandoverPlanResponse: DataResponse<any>;
  detailWasteHandoverPlan?: WasteHandoverPlanModel;
  searchWasteHandoverRegistrationResponse: DataResponse<any[]>;

  // Lịch sử chỉnh sửa
  dataHistory: DataResponse<HistoryEditModel[]>
};

export interface IWasteHandoverPlanPresenter {
  createStore(): WasteHandoverPlanStore;
  searchWasteHandoverPlans(
    store: WasteHandoverPlanStore,
    data: WasteHandoverPlanSearchPayload
  ): Promise<void>;
  createWasteHandoverPlan(data: WasteHandoverPlanCreateRequest): Promise<DataResponse<any>>;
  updateWasteHandoverPlan(data: WasteHandoverPlanUpdateRequest): Promise<DataResponse<any>>;
  getWasteHandoverPlanDetail(id: string): Promise<DataResponse<WasteHandoverPlanModel | undefined>>;
  exportWasteHandoverPlanList(data: WasteHandoverPlanExportPayload): Promise<void>;
  exportWasteHandoverPlanCreateTemplate(): Promise<void>;
  exportWasteHandoverPlanEditTemplate(data: WasteHandoverPlanExportPayload): Promise<void>;
  sendEmail(data: WasteHandoverPlanSendEmailPayload): Promise<DataResponse<any>>;
  deleteWasteHandoverPlan(id: string): Promise<DataResponse<any>>;
  createWasteHandoverRegistration(data: WasteHandoverRegistrationCreateRequest): Promise<DataResponse<any>>;
  updateWasteHandoverRegistration(data: WasteHandoverRegistrationUpdateRequest): Promise<DataResponse<any>>;
  searchWasteHandoverRegistration(store: WasteHandoverPlanStore, data: WasteHandoverRegistrationSearchPayload): Promise<void>;
  getDetailWasteHandoverRegistration(wasteHandoverRegistrationId: string): Promise<any | undefined>;
  cancelWasteHandoverRegistration(data: { cancelReason: string; wasteHandoverRegistrationId: string }): Promise<boolean>;


  importExcel(data: any): Promise<DataResponse<any>>;

  // Lịch sử chỉnh sửa
  getHistory(store: WasteHandoverPlanStore, data: SearchHistory): Promise<void>
}

export function createWasteHandoverPlanPresenter({
  wasteHandoverPlanServices,
}: {
  wasteHandoverPlanServices: IWasteHandoverPlanServices;
}): IWasteHandoverPlanPresenter {
  return {
    createStore: (): WasteHandoverPlanStore =>
      observable({
        searchWasteHandoverPlanResponse: {
          data: [],
          isSuccess: false,
          message: '',
        },
        searchWasteHandoverRegistrationResponse: {
          data: [],
          isSuccess: false,
          message: '',
        },
        createWasteHandoverPlanResponse: {
          data: null,
          isSuccess: false,
          message: '',
        },
        updateWasteHandoverPlanResponse: {
          data: null,
          isSuccess: false,
          message: '',
        },
        dataHistory: {
          data: [],
          isSuccess: false,
          message: ''
        },

      }),

    searchWasteHandoverPlans: async (store, data) => {
      try {
        const result = await wasteHandoverPlanServices.searchWasteHandoverPlans(data);
        runInAction(() => {
          store.searchWasteHandoverPlanResponse = result;
        });
      } catch (error) {
        console.log(error);
      }
    },

    createWasteHandoverPlan: async (data) => {
      try {
        const result = await wasteHandoverPlanServices.createWasteHandoverPlan(data);
        return result;
      } catch (error) {
        console.log(error);
        return {
          data: null,
          isSuccess: false,
          message: 'Có lỗi xảy ra',
        };
      }
    },

    updateWasteHandoverPlan: async (data) => {
      try {
        const result = await wasteHandoverPlanServices.updateWasteHandoverPlan(data);
        return result;
      } catch (error) {
        console.log(error);
        return {
          data: null,
          isSuccess: false,
          message: 'Có lỗi xảy ra',
        };
      }
    },

    getWasteHandoverPlanDetail: async (id) => {
      try {
        const result = await wasteHandoverPlanServices.getWasteHandoverPlanDetail(id);
        return result;
      } catch (error) {
        console.log(error);
        return {
          data: undefined,
          isSuccess: false,
          message: 'Có lỗi xảy ra',
        };
      }
    },
    exportWasteHandoverPlanList: async (data) => {
      try {
        await wasteHandoverPlanServices.exportWasteHandoverPlanList(data);
      } catch (error) {
        console.log(error);
      }
    },
    exportWasteHandoverPlanCreateTemplate: async () => {
      try {
        await wasteHandoverPlanServices.exportWasteHandoverPlanCreateTemplate();
      } catch (error) {
        console.log(error);
      }
    },
    exportWasteHandoverPlanEditTemplate: async (data) => {
      try {
        await wasteHandoverPlanServices.exportWasteHandoverPlanEditTemplate(data);
      } catch (error) {
        console.log(error);
      }
    },
    sendEmail: async (data) => {
      try {
        const result = await wasteHandoverPlanServices.sendEmail(data);
        return result;
      } catch (error) {
        console.log(error);
        return {
          data: null,
          isSuccess: false,
          message: 'Có lỗi xảy ra',
        };
      }
    },
    deleteWasteHandoverPlan: async (id) => {
      try {
        const result = await wasteHandoverPlanServices.deleteWasteHandoverPlan(id);
        return result;
      } catch (error) {
        console.log(error);
        return {
          data: null,
          isSuccess: false,
          message: 'Có lỗi xảy ra khi xóa kế hoạch',
        };
      }
    },
    createWasteHandoverRegistration: async (data) => {
      try {
        const result = await wasteHandoverPlanServices.createWasteHandoverRegistration(data);
        return result;
      } catch (error) {
        console.log(error);
        return {
          data: null,
          isSuccess: false,
          message: 'Có lỗi xảy ra khi tạo phiếu đăng ký',
        };
      }
    },
    updateWasteHandoverRegistration: async (data) => {
      try {
        const result = await wasteHandoverPlanServices.updateWasteHandoverRegistration(data);
        return result;
      } catch (error) {
        console.log(error);
        return {
          data: null,
          isSuccess: false,
          message: 'Có lỗi xảy ra khi cập nhật phiếu đăng ký',
        };
      }
    },
    searchWasteHandoverRegistration: async (store, data) => {
      try {
        const result = await wasteHandoverPlanServices.searchWasteHandoverRegistration(data);
        runInAction(() => {
          store.searchWasteHandoverRegistrationResponse = result;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getDetailWasteHandoverRegistration: async (wasteHandoverRegistrationId) => {
      try {
        const result = await wasteHandoverPlanServices.getDetailWasteHandoverRegistration(wasteHandoverRegistrationId);
        if (result && result.isSuccess) {
          return result.data;
        }
        return undefined;
      } catch (error) {
        console.log(error);
        return undefined;
      }
    },
    cancelWasteHandoverRegistration: async (data) => {
      try {
        const { message } = await import('antd');
        const result = await wasteHandoverPlanServices.cancelWasteHandoverRegistration(data);
        if (result.isSuccess) {
          message.success(result.message);
        } else {
          message.error(result.message);
        }
        return result.isSuccess;
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    // Lịch sử chỉnh sửa
    getHistory: async (store, data) => {
      try {
        const result = await wasteHandoverPlanServices.getHistory(data);
        runInAction(() => {
          store.dataHistory = result;
        });
      } catch (error) {
      }
    },
    importExcel: async (data) => {
      try {
        const result = await wasteHandoverPlanServices.importExcel(data);
        return result;
      } catch (error) {
        console.log(error);
        return {
          data: null,
          isSuccess: false,
          message: 'Có lỗi xảy ra',
        };
      }
    },
  };
}

